import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            观影常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于青柠影院电影在线观看的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}